export class Files {
    public name: string;
    public extension: string;
    public lastModified: string;
    public etag: string;
    public size: number;
}